<csl-non-prod-banner [environment]="environment"></csl-non-prod-banner>
<div id="layout-container">

  @if (this.globalStore.progBarIsLoading()) {
    <p-progress-bar mode="indeterminate" [style]="{'height': '0.4em'}" color="#015989"></p-progress-bar>
  }
  @if (!this.globalStore.progBarIsLoading()) {
    <div class="progress-bar"></div>
  }

  <nav>
    <app-clinic-site-header></app-clinic-site-header>
  </nav>

  <app-home-breadcrumb></app-home-breadcrumb>

  <div class="content">
    <aside>
      <ul>
        <!--        <li><a routerLinkActive="active-button" routerLink="dashboard"><i class="fa-solid fa-gauge fa-xl mr-2 opacity-75 min-w-6"></i>Dashboard</a></li>-->
        <li><a routerLinkActive="active-button" routerLink="hr-index"><i class="fa-solid fa-clipboard-medical fa-xl mr-2 opacity-75 min-w-6"></i>Health Records</a></li>

        @if(globalStore.loggedInUser()?.isClinicStaff && globalStore.loggedInUser()?.clinicStaffProfile?.isMrrContact) {
          <li><a routerLinkActive="active-button" routerLink="mrr-index" class="two-line-text">
            <div class="flex flex-row items-center">
              <div class="flex flex-row items-center">
                <i class="fa-solid fa-file-signature fa-xl mr-2 opacity-80 min-w-5"></i>
                <span class="inline-block">Medical Record Releases</span>
              </div>
              @if(clinicGlobalStore.pendingMedicalRecordReleaseCount() > 0) {
                <csl-count-badge [value]="clinicGlobalStore.pendingMedicalRecordReleaseCount()"></csl-count-badge>
              }
            </div>
          </a></li>
        }

        <li><a routerLinkActive="active-button" routerLink="scp-worklist" class="two-line-text">
          <div class="flex flex-row items-center justify-between">
            <div class="flex flex-row items-center">
              <i class="fa-solid fa-cloud-arrow-up fa-xl mr-2 opacity-80 min-w-5"></i>
              <span class="inline-block">SCP Upload<br/>Worklist</span>
            </div>
            @if(clinicGlobalStore.scpWorklistQueuedCount() > 0) {
              <csl-count-badge [value]="clinicGlobalStore.scpWorklistQueuedCount()"></csl-count-badge>
            }
          </div>
        </a></li>

        <li><a routerLinkActive="active-button" routerLink="transfer" class="two-line-text">
          <div class="flex flex-row items-center justify-between">
            <div class="flex flex-row items-center">
              <i class="fa-solid fa-swap fa-xl fa-rotate-90 mr-2 opacity-75 min-w-6"></i>
              <span class="inline-block">Owner<br/>Transfers</span>
            </div>
            @if (clinicGlobalStore.pendingOwnerTransferRequestCount() > 0) {
              <csl-count-badge [value]="clinicGlobalStore.pendingOwnerTransferRequestCount()"></csl-count-badge>
            }
          </div>
        </a></li>

        <li><a routerLinkActive="active-button" routerLink="clinic-docs"><i class="fa-solid fa-folder-medical fa-xl mr-2 opacity-75 min-w-6"></i>Clinic Documents</a></li>
        <li>
          <a routerLinkActive="active-button" routerLink="messages">
            <div class="flex flex-row items-center justify-between">
              <div class="flex flex-row items-center">
                <i class="fa-solid fa-message fa-xl mr-2 opacity-75 min-w-6"></i>
                <span class="inline-block">Messages</span>
              </div>
              @if(clinicGlobalStore.unreadMessageCount()) {
                <csl-count-badge [value]="clinicGlobalStore.unreadMessageCount()"></csl-count-badge>
              }
            </div>
          </a>
        </li>
        @if(globalStore.loggedInUser()?.isClinicStaff && globalStore.loggedInUser()?.clinicStaffProfile?.isPrimaryContact) {
          <li><a routerLinkActive="active-button" routerLink="clinic-staff"><i class="fa-solid fa-users-medical fa-xl mr-2 opacity-75 min-w-6"></i>Clinic Staff</a></li>
        }
        <li><a routerLinkActive="active-button" routerLink="users"><i class="fa-solid fa-users fa-xl mr-2 opacity-75 min-w-6"></i>Users</a></li>
        @if (featureFlagService.isEnabled('pfc_integration')) {
          <li>
            <a routerLinkActive="active-button" routerLink="pfc-sessions" class="two-line-text">
              <div class="flex flex-row items-center">
                <img [src]="pfcLogoUrl" alt="Passport for Care" class="mr-2 pfc-nav-icon" style="width: 1.6rem; height: 1.6rem; object-fit: contain;">
                <span class="inline-block">Passport<br/>for Care</span>
              </div>
            </a>
          </li>
        }
      </ul>
    </aside>

    <div class="flex flex-col w-full">

      <main class="p-6">
        <router-outlet></router-outlet>
      </main>

    </div>

  </div>

  <app-clinic-site-footer></app-clinic-site-footer>

</div>

<div id="messages-toast" class="card flex justify-center">
  <p-toast />
</div>

<p-drawer id="helpDrawer" [visible]="showHelp()" position="bottom" [style]="{ 'height': 'auto', 'border-top-left-radius': '20px', 'border-top-right-radius': '20px'}" (onHide)="onHelpDrawerHide()">
  <div [innerHTML]="helpService.helpContent()"></div>
  <ng-template #header>
    <span class="font-semibold text-xl text-gray-500">{{helpService.helpTitle() ?? 'SurvivorLink Help'}}</span>
  </ng-template>
</p-drawer>
